import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import { Spinner } from "@/components/ui/spinner";

interface LoadingStateProps {
  variant?: "fullPage" | "card" | "inline" | "skeleton";
  message?: string;
  rows?: number;
  className?: string;
}

export const LoadingState = ({
  variant = "fullPage",
  message = "Loading...",
  rows = 3,
  className,
}: LoadingStateProps) => {
  if (variant === "skeleton") {
    return (
      <div className={cn("space-y-3", className)}>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <div className={cn("flex items-center gap-2 text-sm text-muted-foreground", className)}>
        <Spinner size={18} />
        <span>{message}</span>
      </div>
    );
  }

  if (variant === "card") {
    return (
      <div className={cn("flex flex-col items-center justify-center py-12", className)}>
        <Spinner size={36} className="mb-3" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    );
  }

  // fullPage variant
  return (
    <div className={cn("flex flex-col items-center justify-center min-h-[400px]", className)}>
      <Spinner size={56} className="mb-4" />
      <p className="text-muted-foreground">{message}</p>
    </div>
  );
};
